import { useTranslation } from "react-i18next";
import { statusBadgePalette, type DeliveryStatus } from "../api/deliveries";

const STATUS_KEY: Record<DeliveryStatus, string> = {
  ANNOUNCED: "announced",
  CONFIRMED: "confirmed",
  SAMPLED: "sampled",
  LAB_REJECTED: "labRejected",
  CANCELLED: "cancelled",
  RECEIVED: "received",
  SETTLED: "settled",
  REJECTED: "rejected",
};

export function DeliveryStatusBadge({ status }: { status: DeliveryStatus }) {
  const { t } = useTranslation();
  const c = statusBadgePalette(status);
  const label = t(`deliveries.status.${STATUS_KEY[status]}`, { defaultValue: status });
  return (
    <span
      style={{
        background: c.bg,
        color: c.fg,
        padding: "2px 8px",
        borderRadius: 999,
        fontSize: 11,
        fontWeight: 600,
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </span>
  );
}
